import { useState, useCallback } from 'react';

const useMultiSelection = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleRowSelection = useCallback((rowKeys, rows) => {
    setSelectedRowKeys(rowKeys);
    setSelectedRows(rows);
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
  }, []);

  const hasSelection = selectedRowKeys.length > 0;

  return {
    selectedRowKeys,
    selectedRows,
    handleRowSelection,
    clearSelection,
    hasSelection,
  };
};

export default useMultiSelection;
